import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import classNames from "classnames";
import { Button, Input, Label, Loader, WhiteLabel } from '../../components'

import classes from "./ResetPasswordComponent.module.scss";
import { CognitoAuthApi } from '../../services/Api/CognitoAuthApi';
import { Sendum } from '../../Sendum'
export interface IProps {
    code: string;
}

export const ResetPasswordComponent = ({code}: IProps) => {
    const [isLoading, setLoading] = useState<boolean>(false);
    const [pwd, setPwd] = useState<string>("");
    const [confirmedPwd, setConfirmedPwd] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [errorShortPwdLength, setErrorShortPwdLength] = useState<boolean>(false);
    const [errorMismatchPwd, setErrorMismatchPwd] = useState<boolean>(false);
    const [errorRequiredPwd, setErrorRequiredPwd] = useState<boolean>(false);
    const [errorRequiredConfirmedPwd, setErrorRequiredConfirmedPwd] = useState<boolean>(false);

    const pwdInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPwd(event.target.value || "");
    };

    const confirmedPwdInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmedPwd(event.target.value || "");
    };

    const resetPasswordButtonOnClickHandler = () => {
        if (isLoading) {
            return;
        }

        const _errorRequiredPwd = !pwd;
        const _errorRequiredConfirmedPwd = !confirmedPwd;
        const _errorShortPwdLength = pwd?.length < 6;
        const _errorMismatchPwd = pwd !== confirmedPwd;

        setErrorShortPwdLength(_errorShortPwdLength);
        setErrorMismatchPwd(_errorMismatchPwd);
        setErrorRequiredPwd(_errorRequiredPwd);
        setErrorRequiredConfirmedPwd(_errorRequiredConfirmedPwd)

        if (_errorRequiredPwd || _errorRequiredConfirmedPwd || _errorShortPwdLength || _errorMismatchPwd) {
            return;
        }

        setLoading(true);

        new CognitoAuthApi().resetPassword(code, pwd)
            .then((res) => {
                console.log(res);
                // window.location.href = '/';
                Sendum.getBrowserHistory().push('/');

            })
            .catch(error => {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (!code) {
            return;
        }

        setLoading(true);

        new CognitoAuthApi().confirmResetPassword(code)
            .then((res) => {
                setUsername(res.email);
            })
            .catch(error => {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
                // window.location.href = '/';
                Sendum.getBrowserHistory().push('/');
            })
            .finally(() => setLoading(false))
    }, [code])

    return (
        <div className={classes.reset}>
            <div className={classes.reset__column}>
                <WhiteLabel/>
                <div className={classes.reset__title}>Reset Password</div>
                <form className={classNames(classes.reset__form, classes.form)}>
                    {isLoading && (<Loader className={classes.form__loading} />)}
                    <div className={classes.form__column}>
                        <div>{username}</div>
                        <Label text={"Enter a new password"} >
                            <Input
                                placeholder={"Password *"}
                                value={pwd}
                                onChange={pwdInputOnChangeHandler}
                                name={pwd}
                                autoComplete={"on"}
                                type={"password"}
                            />
                            <>{errorRequiredPwd && (<div className={classes.form__error}>Required</div>)}</>
                            <>{!errorRequiredPwd && errorShortPwdLength && (<div className={classes.form__error}>Must be at least 6 characters.</div>)}</>
                        </Label>
                        <Label text={"Please confirm"} >
                            <Input
                                placeholder={"Confirmed Password *"}
                                value={confirmedPwd}
                                onChange={confirmedPwdInputOnChangeHandler}
                                name={confirmedPwd}
                                autoComplete={"on"}
                                type={"password"}
                            />
                            <>
                                {errorRequiredConfirmedPwd && (<div className={classes.form__error}>Required</div>)}
                                {!errorRequiredConfirmedPwd && errorMismatchPwd && <div className={classes.form__error}>Passwords must match!</div>}
                            </>
                        </Label>
                        <Button className={classes.form__button} title={"Submit"} onClick={resetPasswordButtonOnClickHandler} />
                    </div>
                </form>
            </div>
        </div>
    )
}